import { RegionCode } from "../constants";

/**
 * Maps a 2-letter ISO country code from IPinfo to a supported app RegionCode.
 * unknown / foreign countries map to EN-GLOBAL.
 */
export function mapCountryToRegion(countryCode: string | null): RegionCode | null {
    if (!countryCode) return null;
    const code = countryCode.toUpperCase().trim();
    if (code === "FI") return "FI";
    if (code === "SE") return "SE";
    if (code === "IE") return "IE";
    if (code === "GB") return "UK"; // IPinfo returns GB for UK, app uses UK
    return "EN-GLOBAL"; // Maps any other country to EN-GLOBAL
}

/**
 * Fetches the viewer's country code from the IPinfo Lite API.
 * Uses the environment variable REACT_APP_IPINFO_TOKEN if present, otherwise
 * falls back to the default token f30fa8142218d2.
 * Includes a 3000ms timeout to prevent hanging connections.
 */
export async function fetchIPCountry(): Promise<string | null> {
    const token = process.env.REACT_APP_IPINFO_TOKEN;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000);

    try {
        const response = await fetch(`https://api.ipinfo.io/lite/me?token=${token}`, {
            signal: controller.signal,
        });
        clearTimeout(timeoutId);

        if (!response.ok) return null;
        const data = await response.json();
        const countryCode = data.country_code || data.country;
        return countryCode ? countryCode.trim().toUpperCase() : null;
    } catch (error) {
        clearTimeout(timeoutId);
        // Fail silently to trigger standard browser locale fallback
        return null;
    }
}
